<template>
  <div class="home">
    <h1>Updated succeeded</h1>
    <p>You can now close this window</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SuccessView'
})
</script>